import { AspectFilterRegistryItem } from '../AspectFilterRegistryItem';
import { AspectFilterRegistryCategory } from '../AspectFilterRegistryCategory';
export class AspectFilterByNameMultiple extends AspectFilterRegistryCategory {
    label = 'Multiple by Name';
    constructor(parent) {
        super(parent);
        const all = {
            po: ['position', 'outer'],
            pi: ['position', 'inner'],
            poi: ['position', 'outer', 'inner'],
        };
        Object.keys(all).forEach(key => {
            this[key] = () => new AspectFilterRegistryItem({
                label: all[key].join(','),
                filter: ({ a }) => all[key].includes(a.name),
            });
        });
        super.init();
    }
    aspectNameIncludes = new AspectFilterRegistryItem({
        label: 'Aspektname enthält',
        filter: ({ a, trait }) => a.name.includes(trait.local.valueOf.aspectName),
        params: { core: ['aspectName'] },
    });
}
